var language_store = $("html").attr('lang');
//console.log(language_store);
window.pwCustomJSLoaded = true;


function pw_post_product_modal_save(personalisationID, thumbURL){

  $(".pwAddToCart").show();
  $(".pwAddToCart").prop('disabled', false);

  $(".product-media-container").addClass("custom-preview");
}

function pw_post_product_modal_cancel(){
  closeDialog();
}

function pw_onready(){
  // if pw_cart_button is disabled we enable as pw is loaded. As long as it's not a Record Text page where it should remain disabled.
  if( $j("#pw_cart_button").prop('disabled')){
    console.debug("pw: personalise button disabled, enabling now...");
    var language_store = $("html").attr('lang');
    
    if(window.translations !== undefined){
      $j("#pw_cart_button").attr( "value", window.translations.personalise );
    }else{
      $j("#pw_cart_button").attr( "value", "Personalise" );
    }
    $j("#pw_cart_button").prop( "disabled", false );
    clearInterval(pwRefreshId);
  }
}

// opens the Printzware Modal Window
function opendialogedit(page) {
	document.ontouchmove = function (e) {
		e.preventDefault();
	}
	// if it's a product call use the correct ModalUrl
	/*if(pwProductMode) {
      if (pwProductSelect !== null) {
        var pwSelectedVariant;
        // if the pwProductSelect is an INPUT field
        if(pwProductSelect !== null && pwProductSelect.prop('nodeName')=='INPUT'){
			if(pwProductSelect.attr('pwdata-sku')){
          		pwSelectedVariant = pwProductSelect.attr('pwdata-sku').split("-");
			}else{
				pwSelectedVariant = pwVariant2pwSku[pwProductSelect.val()].split("-")
			}
        } else {// else as normal select > option
          pwSelectedVariant = pwProductSelect.find(":selected").attr('pwdata-sku').split("-");
        }

        page = urldecode(pwModalUrls[pwSelectedVariant[0]]);

        //check if an product option  has been specific and add it to the Modal URL
        if(typeof pwSelectedVariant[1] !== 'undefined') {
          page = page + pwSelectedVariant[1];
        }
      }
	}*/

	// Check if viewport exists and save original content, apply mobile non-zoom viewport
	viewport = document.querySelector("meta[name=viewport]");
	if (viewport!=null){
		// save the original viewport settings
		origViewportString = viewport.content;
		// set the new viewport to disable zoom on mobile
		viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0');
	}
	else{
		origViewportString = "";
		var metaTag=document.createEulement('meta');
		metaTag.name = "viewport"
		metaTag.content = "width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=0"
		document.getElementsByTagName('head')[0].appendChild(metaTag);
	}

	if (typeof pwJsonData !== 'undefined') {
		page = page + pwJsonData;
	}

	$j('#pw_iframe_edit').attr('src',page);
	if (typeof pw_disable_scrolltop === 'undefined'){
		$j('body').css({'top': ($j(window).scrollTop() * -1)+'px'});
	}
	$j('#pw_modal').addClass('in');
	$j('#pw_modal').modal('show');
	$j('body').addClass('pw-modal-open');
	$j('#pw_modal').show();
	$j('.modal-backdrop').detach().appendTo('.bootstrap-wrapper');
	$j('.modal-backdrop').click(function(){
		closeDialog();
	});
}

function editOrderTest(personalisationID){
	var url = decodeURIComponent(pwCartPersonalisationUrls[personalisationID])
    //console.log(url);
	opendialogedit(url);
}



function closeDialog() {
    document.ontouchmove = function (e) {
        return true;
    }
    var offset = parseInt($j("body").css('top'), 10);
    var scrollingElement = document.scrollingElement || document.documentElement;
    $j("body").removeClass("modal-open pw-modal-open");
    $j("body").css({'padding-right': '0px'});
    if (typeof pw_disable_scrolltop === 'undefined') {
        $j(window).scrollTop(offset * -1);
    }
    // apply the original viewport
    viewport = document.querySelector("meta[name=viewport]");
    viewport.setAttribute('content', origViewportString);
    // set iframe to blank page and close
    $j('#pw_iframe').attr('src', 'about:blank');
    $j('#pw_modal').modal('hide');
    $j('#pw_modal').removeClass('in');
    $j('#pw_modal').hide();
    $j('.bootstrap-wrapper .modal-backdrop').remove();
}

var getUrlParameter = function getUrlParameter(sParam) {
    var sPageURL = window.location.search.substring(1),
        sURLVariables = sPageURL.split('&'),
        sParameterName,
        i;

    for (i = 0; i < sURLVariables.length; i++) {
        sParameterName = sURLVariables[i].split('=');

        if (sParameterName[0] === sParam) {
            return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
        }
    }
    return false;
};


document.addEventListener('DOMContentLoaded', function load() {
  
  
  

    $(document).on('click', 'body.product-guinness-world-record-officially-amazing-pin-badge .pwAddToCart', function(){

       var newPWOrderID = (new Date().getTime()).toString(16)+Math.random().toString(36).slice(11);
        $("#pw_order_id").val(newPWOrderID);

    });

    $(document).on('click', '.hasPWPromotion', function () {

        // Wait a bit so Shopify finishes adding Product A
        setTimeout(function() {
            const giftVariantID = $("#pw-upsell-variant-id").val(); // Replace with your gift variant ID

            // Get current cart
            $.getJSON('/cart.js', function(cart) {
                const giftExists = cart.items.some(item => item.variant_id == giftVariantID);

                var pwOrderID = (new Date().getTime()).toString(16)+Math.random().toString(36).slice(11);

                if (!giftExists) {
                    // Add gift product
                    $.ajax({
                        type: 'POST',
                        url: '/cart/add.js',
                        data: {
                          id: giftVariantID,
                          quantity: 1,
                          properties: {
                                "_pwOrderID": pwOrderID,
                                "_pwStaticProduct": 1
                          }
                        },
                        dataType: 'json',
                        success: function() {
                            // Refresh cart drawer or page
                            window.location.reload();
                        }
                    });
                }
            });
        }, 2000); // small delay to wait for product A to finish adding
    });

   if( ($(".border-section #record-title").length) || ($(".border-section #country").length) || ($(".pwRecordTextForm").length) || ($(".withoutFirstSection").length) ){

        function firstSectionSelects(selectName) {
          var country = $("select#country").val(); // value of country select field
            var year = $("select#year").val(); // value of year select field
            var month = $("select#month").val(); // value of month select field
          var recordTitle = $("select#record-title").val(); // value of month select field
            $("#pw_cart_button").attr("disabled", true);
           // check if ALL 3 select fields have a value
          if( (country != "") && (year != "") && (month != "") && $(".main-pw-record-template").length){
            //$(".record-select").show();
          if (recordTitle == "") {
            $(".second-custom-section").show();
            $(".second-subheading").show();
            $(".second-custom-section .second-section-content").hide(); // hide only dynamic bits
            $("#pw_cart_button").attr("disabled", true);
          }
            $.ajax({
                url: '/a/greeting-cards/index.php?year='+year+'&month='+month+'&country='+country,
                type: 'POST',
                data: { func: "custom", func2 : "getListOfRecords"},
                dataType: 'json',
                success: function(data) {
                   //console.log(data)
                  $("#spinner").hide();
                  $(".second-custom-section .second-section-content").show(); // if all are selected show second section
                  if(selectName != "record-title"){
                    $('#record-title').empty();
                    $('#record-title').append('<option value="">Select Record Title</option>');

                    data.forEach((record) => {
                      //console.log(record);
                      $('#record-title').append('<option value="'+record.Id+'">'+record.Title+'</option>');
                    });
                  }
                 $(".no-results").remove();
                   // console.log(data)
                  if(data == ""){
                    $(".record-select").hide();

                    $(".second-custom-section .second-section-content").hide();
                    $("#spinner").hide();

                     $(".second-subheading").hide();
                     $("#pw_cart_button").attr("disabled", true);
                     $('#record-title').empty();
                  $('#record-title').append('<option value="">Select your record title</option>');
                     $('select#month').after('<div class="no-results"><p id="first-sentence">Hmm, we can’t find any records based on your selection, why not have another try?</p><br> <span id="search-again">Search Again</span></div>');
                    $('#search-again').on('click', function(e){
                        $(".no-results").remove();
                    });
                  } else{

                     $(".record-select").show();
                    $(".no-results").remove();
                    // $("#pw_cart_button").attr("disabled", false);
                  }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                  console.error("Error fetching line-item-list content:", errorThrown);
                }
              });
          }
           if( (country != "") && (year != "") && (month != "") && (recordTitle != '') ){
             $(".second-custom-section").show();
             $(".second-subheading").show();
             $("#spinner").show();
             $("#pw_cart_button").attr("disabled", false);
            $(".second-custom-section .second-section-content").hide();

           } else{
             // if all are not selected hide second section
             // $(".second-custom-section").hide();
             $("#pw_cart_button").attr("disabled", true);
           }
        }

       function secondSectionSelects(recordTitle) {

         if(isNaN(recordTitle) || recordTitle == "") {
           var recordTitle = $("select#record-title").val(); // value of record title select field
         }

           //on change check if Record title value is empty or not
           //if NOT empty enable personalise bttn
           if( recordTitle != "" ){
              var pwJsonData = null;
             $("#spinner").show();
             $(".second-custom-section .second-section-content").hide();
              $.ajax({
                url: '/a/greeting-cards/index.php?certType=COP&id='+recordTitle,
                type: 'POST',
                data: { func: "custom", func2 : "getTextByID"},
                dataType: 'text',
                success: function(data) {
									//console.log('record', data);
                  $("#spinner").hide();
                  $(".second-custom-section .second-section-content").show();
                  // $('#record-title').empty();
                  //  $('#record-title').append('<option value="">Select Record Title</option>');

                  pwJsonDataObject = {"variables":{"recordText":data},"textboxes":{"p1":{"text004":{"value":data}}}};
                  window.pwJsonData = "&pwJsonData="+encodeURIComponent(JSON.stringify(pwJsonDataObject));
                  //console.log(data);
                  if((data == "An error occurred: Could not convert ApplicationId to int") || (data == "No text associated with the provided certificate ID.")){
                   $("#pw_cart_button").attr("disabled", true);
                    alert(data);
                  } else{
                   $("#pw_cart_button").attr("disabled", false);
                    // added by MMG. GWR require the GWRTextID added per line item
                      $('<input>').attr({
                          type: 'hidden',
                          id: 'gwr_text_id',
                          name: 'properties[GWRTextID]',
                        value: recordTitle
                      }).insertAfter($('#pw_personalisation_id'));
                  }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                  console.error("Error fetching line-item-list content:", errorThrown);
                }
              });
             //if NOT empty enable personalise bttn

           } else{
             //if empty disable personalise bttn

             $("#pw_cart_button").attr("disabled", true);

           }
       }
        $(".second-custom-section").hide();
        //on select first section change event
        $('.border-section.first-custom-section select').on('change', function(e){
              var selectName = $(this).attr("id");

              firstSectionSelects(selectName);
              pwVariationChange(language_store);
        });
       firstSectionSelects();



     var rID = getUrlParameter('rID');
     //console.log(rID);

       rID = parseInt(rID,10);

       secondSectionSelects(rID);


       $('.border-section select#record-title').on('change', function(e){

                secondSectionSelects();
               var recordID = $(this).val();
                //console.log(recordID)
                pwVariationChange(recordID);
        });


       var productID = meta.product.id;
       if($(".pw-record-holder").length){
         var customerId =  meta.page.customerId;
         if(customerId){
              var multipass_identifier;
               $.ajax({
                url: '/a/greeting-cards/index.php?customer_id='+customerId,
                type: 'POST',
                data: { func: "custom", func2 : "getCustomer"},
                dataType: 'json',
                success: function(data) {
                  multipass_identifier = parseInt(data.customer.multipass_identifier);

                  if(multipass_identifier){
                    getUserByMultipassIdentifier(multipass_identifier);
                  }
                },
                error: function(jqXHR, textStatus, errorThrown) {
                  console.error("Error fetching line-item-list content:", errorThrown);
                }
              });
         } else{
            // No records found, please contact Guinness World Records for assistance
           console.debug("No records found, please contact Guinness World Records for assistance")
              $('.first-custom-section').append('<div class="no-results"><p id="first-sentence">No records found, please contact Guinness World Records for assistance</p></div>');
               $(".border-section.second-custom-section").show();
         }


   function getUserByMultipassIdentifier(multipass_identifier){
       //$(".special-hide").hide();
       $(".record-select").show();
      /*$("select#country").val(0);
       $("select#year").val(0);
       $("select#month").val(0);*/
      $(".subheading.second-subheading").show();
      $(".second-custom-section").show();
      $.ajax({
          url: '/a/greeting-cards/index.php?userID='+multipass_identifier,
          type: 'POST',
          data: { func: "custom", func2 : "getRecordsByUser"},
          dataType: 'json',
          success: function(data) {
            if(data.length > 0){

              $('#record-title').empty();
                  $('#record-title').append('<option value="">Select Record Title</option>');
                  data.forEach((data) => {
                    $('#record-title').append('<option value="'+data.Id+'">'+data.Title+'</option>');
                  });
            } else{
               $('select#record-title').after('<div class="no-results"><p id="first-sentence">Hmm, we can’t find any records based on your selection, why not have another try?</p><br> <span id="search-again">Search Again</span></div>');
              $('#search-again').on('click', function(e){
                  $(".no-results").remove();
              });
            }
          },
          error: function(jqXHR, textStatus, errorThrown) {
            console.error("Error fetching line-item-list content:", errorThrown);
          }
        });
    }

       }


     //secondSectionSelects();
    }

  	 var pw_button = $("#pw_cart_button");
     var staticProduct = $("#pw_static_product");

     if ($(".product").length && (pw_button.length || staticProduct.length) ){
        setTimeout(function(){
       		$(".shopify-payment-button").hide();
         },1000);



      $(document).on("click", ".pwAddToCart", function(){
        var product_id = $("input[name=product-id]").val();
        //  setTimeout(function(){
        //        if(product_id != "14877416915329"){
        //          location.reload();
        //        } else{
        //           window.location.href = "/cart";
        //        }

        //  },500);

      });

       $(document).on("change", ".selector-wrapper select", function(e){
       	$(".shopify-payment-button").hide();
       });

        $(document).on("click", ".planet-volume-volumeItem", function(){
            setTimeout(function(){

              // $(".product-variant-id").prop('disabled', false);
           },1000);
        });

       /* $(document).on("click",  ".pwAddToCart", function(){
            setTimeout(function(){

               var newPWOrderID = (new Date().getTime()).toString(16)+Math.random().toString(36).slice(11);
               $("#pw_order_id").val(newPWOrderID);
           },1000);
        }); */
     }


    var GWRTextID = $("#GWRTextID").val();
  //  console.log(GWRTextID);

    if(GWRTextID){

      $(".subheading, .first-custom-section").hide();
      $(".border-section.second-custom-section").show();
      $(".border-section.second-custom-section").removeClass("border-section second-custom-section");

      $("#pw_cart_button").attr("disabled", false);
      secondSectionSelects(GWRTextID);
    }


    if($(".product").length && pw_button.length){
      $("body").addClass("pw-product");

      function personaliseButton(language_store){

        $("body").on('DOMSubtreeModified', "#pw_personalisation_id", function() {
         
          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Personalise" && language_store == 'en'){
            $('#pw_cart_button').val('Edit');
            $('#pw_cart_button').addClass('edit-pw-bttn');
            setTimeout(function(){
              $(".pwAddToCart").show();
            },1000);
          }
          

        });


        // Select the node that will be observed for mutations
        var targetNode = document.getElementById('pw_personalisation_id');

        // Options for the observer (which mutations to observe)
        var config = { attributes: true, childList: true };

        // Callback function to execute when mutations are observed
        var callback = function(mutationsList) {
          //for(var mutation of mutationsList) {
          for(var mutation in mutationsList) {

            var pw_button_text = $("#pw_cart_button").val();
            if(pw_button_text == "Personalise" && language_store == 'en'){
              $('#pw_cart_button').val('Edit');
              $('#pw_cart_button').addClass('edit-pw-bttn');
              setTimeout(function(){
                $(".pwAddToCart").show();
              },1000);
            }
          }

        };

        // Create an observer instance linked to the callback function
        var observer = new MutationObserver(callback);

        // Start observing the target node for configured mutations
        observer.observe(targetNode, config);

        var pw_button = $("#pw_cart_button");
        if (typeof pw_button  !== "undefined"){
          setTimeout(function(){
            $(".shopify-payment-button, .pwAddToCart").hide();
          },3000);

        }
      }

      personaliseButton(language_store);


      function pwVariationChange(language_store){
        var pw_cart_button = $("#pw_cart_button").html();
        if (typeof  pw_cart_button !== 'undefined'){
          var pw_button_text = $("#pw_cart_button").val();
          if(pw_button_text == "Edit"){

            var product_image_original = $('meta[property="og:image"]').attr('content');

            setTimeout(function(){

              $(".product__media img").attr("data-src", product_image_original);
              $(".product__media img").attr("data-bgset", product_image_original);
              $(".product__media img").attr("src", product_image_original);
              $(".product__media img").attr("srcset", product_image_original);
              $(".product-media-container").removeClass("custom-preview");

            }, 500);

            if (document.documentMode || /Edge/.test(navigator.userAgent)) {
              if(language_store == 'en'){
                $("#pw_cart_button").prop('value', 'Personalise');
              }

            } else{
              if(language_store == 'en'){
                $('#pw_cart_button').val('Personalise');
              }
            }
            $('#pw_cart_button').removeClass('edit-pw-bttn');


          }

          setTimeout(function(){
              $(".shopify-payment-button, .pwAddToCart").hide();

           },500);

        }

      }
       $('ul.options-list li input').on("click", function(e){

         pwVariationChange(language_store);


          setTimeout(function(){
             var variant_id = $(".test-input").val();

             $(".pwProductSelect option").removeAttr('selected');
             $('.pwProductSelect option[value="'+variant_id+'"]').attr('selected', 'selected');


          },500);
      });
    }




  	function replacePWimages(){

      var textArray = $("#CartDrawer-Form .cart-items .cart-item .cart-item__details .product-option:contains('PersonalisationID')");

      textArray.each(function() {

        var cardID = this.textContent.trim();
        cardID = cardID.replace(/\s/g, '');
        cardID = cardID.match(/PersonalisationID:.*/);
        cardID = cardID[0];
        cardID = cardID.replace("PersonalisationID:", "").trim();
        var rand = Math.floor(Math.random() * 10000);
        var newSrc = "https://url.uk.m.mimecastprotect.com/s/aRVPCMjqRi5y2p2UWsBC8vus4?domain=pwcdn.net"+cardID+".jpg?r="+rand;
        $(this).parent().parent().parent().find("img").addClass("pwThumbImage");
        $(this).parent().parent().parent().find("img").attr("src",newSrc);
        $(this).parent().parent().parent().find("img").attr("srcset",newSrc);

      });
    }



    function addPreviewLinkSidecart(){
          var textArray = $("#CartDrawer-Form .cart-items .cart-item .cart-item__details .product-option:contains('PersonalisationID')");
      //console.log(textArray);
      var pwCartPersonalisationIDs = [];
          textArray.each(function() {

              var personalisationID = this.textContent.trim();
              personalisationID = personalisationID.replace(/\s/g, '');
              personalisationID = personalisationID.match(/PersonalisationID:.*/);
              personalisationID = personalisationID[0];
              personalisationID = personalisationID.replace("PersonalisationID:", "").trim();

              // remove any space etcafter personalisationID
              personalisationID = personalisationID.match(/[^\s]+/);
              personalisationID = personalisationID[0];

              pwCartPersonalisationIDs.push(personalisationID);

			});

            //var pwCartPersonalisationIDs  = ['66a2220ded294', '66a20908abb6c'];
            //console.log(pwCartPersonalisationIDs);
            $.ajax({
                type: 'POST',
                url: window.location.origin+"/a/greeting-cards/index.php",
                data: {"func":"shopifyGetEditOrderLinks","pwEditOrderIDs":pwCartPersonalisationIDs},
                crossDomain: true,
                dataType: 'json',
                success: function(json_data, textStatus, jqXHR) {
                    pwCartPersonalisationUrls = json_data['editOrderUrls'];
                    for(var key in pwCartPersonalisationUrls){
                      //console.log(key)
                      var xpath = '//*[normalize-space(text())="' + key + '"]';
                      var matchingElement = document.evaluate(xpath, document, null, XPathResult.FIRST_ORDERED_NODE_TYPE, null).singleNodeValue;
                      var curText = $(matchingElement).text().trim();
                      var newText;
                     //console.log(matchingElement);
                      //console.log(curText);
                        newText = $(matchingElement).text().replace($(matchingElement).text(), ' <a href="javascript:void(0);" class="pwEditOrderLink" onClick="editOrderTest(\'' + key + '\');">Preview and Edit</a>');
                        $("div > dt:contains('PersonalisationID:')").hide();
                     // console.log(newText);
                      $(matchingElement).html(newText);
                    }
                },
                error: function (json_data, textStatus, errorThrown) {
                    console.debug('pw: ERROR get pwEditOrderIDs failed, edit orders will not work');
                }
            });

    }

// addPreviewLinkSidecart();


  $(document).on("click", ".pwAddToCart, a#cart-icon-bubble", function(){
      setTimeout(function(){
      	replacePWimages();

      },2000);
    // addPreviewLinkSidecart()
    });



    if ($("html").hasClass("cart-template")){





      setTimeout(function(){
      	replacePWimages();
      }, 2000);

      $(document).on("click", "a.cart-item-remove", function(){
      setTimeout(function(){
      	replacePWimages();
      },2000);
    });


      $("#pw_modal").on('hidden.bs.modal', function() {

          setTimeout(function(){
              replacePWimages();
          },1000);
      });
  }

 // var staticProduct = $("#pw_static_product");

if ($(".product").length && (staticProduct.length) ){
  
      var variant_id = $(".test-input").val();
      $("#pw_order_id_test option").removeAttr('selected');
      $('#pw_order_id_test option[value="'+variant_id+'"]').attr('selected', 'selected');
      var orderId = $('#pw_order_id_test option[value="'+variant_id+'"]').attr('pwdata-orderid');
      $("#pw_order_id").val(orderId);
      $(document).on("click", '.product-options  ul.options-list li input', function(e){
      
          setTimeout(function(){
            
             var variant_id = $(".test-input").val();
           
             $("#pw_order_id_test option").removeAttr('selected');
             $('#pw_order_id_test option[value="'+variant_id+'"]').attr('selected', 'selected');

             var orderId = $('#pw_order_id_test option[value="'+variant_id+'"]').attr('pwdata-orderid');
             $("#pw_order_id").val(orderId);
          },200);
      });
         
     }

}, false);

